module.exports = __webpack_public_path__ + "static/grafika4@2x-ec6d2f060627922f5db858f0361427eb.png";